module.exports = __webpack_public_path__ + "img/zhuangshi@3x.3002a657.png";